// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T18:31:58.455Z
// Property: Beck at Wells Branch (ID: 6767906449162864)
// Collections: 95 amenities, 5 floorplans (live), 25 photos, 3 POIs, 62 reviews, 6 virtual tours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162273",
  "multihub_property_id": "6767906449162864",
  "property_external_id": "4489362",
  "property_zillow_url": "https://www.zillow.com/b/2801-w-wells-branch-pkwy-austin-tx-Bry3vV/",
  "property_apartments_url": "https://www.apartments.com/beck-at-wells-branch-austin-tx/n3cqt3m",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "beck-at-wells-branch",
  "property_name": "Beck at Wells Branch",
  "property_website_url": "https://www.beckatwellsbranch.com/",
  "property_domain": null,
  "property_address": "2801 Wells Branch Pkwy",
  "property_full_address": "2801 Wells Branch Pkwy",
  "property_address_1": "2801 Wells Branch Pkwy",
  "property_address_2": null,
  "property_address_city": "Austin",
  "property_address_state": "TX",
  "property_address_zip_full": "78728-6796",
  "property_address_zip": "78728",
  "property_address_country": "US",
  "property_address_county": "Travis County",
  "property_neighborhood_address": "Wells Branch",
  "property_address_latitude": "30.4404252",
  "property_address_longitude": "-97.6897687",
  "property_email": "beck@alapts.com",
  "property_phone": "(512) 255-2654",
  "property_call_tracking_phone": null,
  "property_company_name": "Repli Sandbox",
  "property_company_url": "testurl.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Beck at Wells Branch in Austin, Texas, spacious one, two, and three-bedroom apartments await your personal touch. Enjoy resort-style amenities like a sparkling pool, fitness center, and inviting dog park. Experience comfort with luxurious finishes and community events that foster connection. Your vibrant lifestyle starts here—schedule a tour today!",
  "property_long_description": "**Welcome to Beck at Wells Branch – Your Ideal Austin Apartment Community!**\n\nDiscover the perfect blend of comfort and convenience at Beck at Wells Branch, located in the vibrant heart of Austin, Texas. Our diverse selection of thoughtfully designed floor plans includes spacious one-bedroom, two-bedroom, and three-bedroom apartments, ensuring a perfect fit for everyone, from solo dwellers to families. \n\nEnjoy resort-style amenities that elevate your living experience! Dive into our sparkling pool, break a sweat at the state-of-the-art fitness center, or unwind in the cozy clubhouse. With controlled access, on-site management, and maintenance, your peace of mind is our priority. Plus, our eco-friendly recycling program and planned social activities foster a tight-knit community vibe.\n\nOur pet-friendly apartments feature convenient amenities such as a dog park, pet play area, and a washing station, making it easy to include your furry friends in your lifestyle. Enjoy easy access to public transportation and online services, designed to streamline your routine. \n\nInside, your luxury apartment awaits with high-end finishes like granite countertops, hardwood floors, and stainless steel appliances. Spacious layouts feature walk-in closets, balconies, and patios that enhance your living space, while air conditioning and ceiling fans provide comfort year-round.\n\nDon’t miss out on this incredible community! Find your new home today – browse our availability or schedule a tour to visit Beck at Wells Branch and experience all that we have to offer. Your perfect Austin living experience starts here!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-db5a-7282-96e2-7e00866b188a.webp",
  "property_featured_image_media": {
    "alt_text": "Luxury apartment complex swimming pool with lounge chairs and surrounding trees.",
    "public_id": "019cfdda-db5a-7282-96e2-7e00866b188a",
    "storage_key": "property/6767906449162864/019cfdda-db5a-7282-96e2-7e00866b188a.webp",
    "width": 1240,
    "height": 827
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "576",
  "property_year_built": "1999",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.40277777777779",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": null,
  "property_allows_cats": null,
  "property_allows_dogs": null,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": null,
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-c821-73f8-be9a-0035af35edc5.webp",
  "property_primary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019cfdda-c821-73f8-be9a-0035af35edc5",
    "storage_key": "property/6767906449162864/019cfdda-c821-73f8-be9a-0035af35edc5.webp",
    "width": 325,
    "height": 147
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-c821-73f8-be9a-0035af35edc5.webp",
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": null,
  "property_mono_white_logo_media": null,
  "property_mono_black_logo": null,
  "property_mono_black_logo_media": null,
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019cfdd9-c8a4-71d3-8bff-111ee22aee5d.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
  "property_company_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2713-d4f5-701a-91f4-9c4e82dc6c6b",
    "storage_key": "company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2705-ea93-721c-8d4f-e2d2a439a839",
    "storage_key": "company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": null,
  "property_secondary_color": null,
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "698 - 1415",
  "property_sqft_min": "698",
  "property_sqft_max": "1415",
  "property_price_range": "1000 - 2163.33",
  "property_price_min": "1000",
  "property_price_max": "2163.33",
  "property_available_units": 38,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": null,
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": null,
  "property_home_floorplans_blurb": null,
  "property_home_gallery_blurb": null,
  "property_home_neighborhood_blurb": "Discover the vibrant neighborhood surrounding Beck at Wells Branch in Austin, Texas. With stunning one, two, and three-bedroom floor plans, our community is perfectly situated to explore local favorites and nearby attractions. See what's around our community and start your adventure today! Explore the Beck lifestyle now!",
  "property_home_reviews_blurb": null,
  "property_neighborhood_blurb": "Located about 15 miles north of Downtown Austin and five miles south of Round Rock, Wells Branch is a family-friendly suburb with plenty to see and do. Residents have their choice of a wide variety of apartments and single-family houses available for rent in Wells Branch.\n\t\t\t\t\tThe area offers a delightful suburban experience, with peaceful neighborhoods, scenic parks, and plenty of convenient shopping opportunities. Recreational options abound at Katherine Fleischer Park, Mills Pond Recreation Area, and Wells Branch Disc Golf Course, where residents often gather to enjoy the outdoors. Getting around from Wells Branch is a breeze with quick access to I-35 and the MoPac Expressway.\n\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t\t\tLearn more about living in Wells Branch",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Beck at Wells Branch in Austin, TX, life is a blend of sophistication and convenience. Choose from spacious one, two, or three-bedroom floor plans while enjoying top-tier amenities like our sparkling pool, fitness center, and pet-friendly features. Elevate your lifestyle with modern comforts and community spirit awaiting you!",
  "property_applynow_blurb": "Step into the vibrant life at Beck at Wells Branch, where modern comforts meet unique style in spacious one, two, and three-bedroom apartments. Enjoy exclusive amenities like a refreshing pool, state-of-the-art fitness center, and dog park, making every day a delightful experience. Your ideal Austin living awaits—lease online today!",
  "property_contactus_blurb": "Discover your perfect home at Beck at Wells Branch in Austin, Texas! Choose from spacious one, two, or three-bedroom floor plans designed for comfort and style. Have questions? Contact our leasing team today to learn more and schedule your visit to our vibrant community!",
  "property_faqs_blurb": "Explore comfortable living at Beck at Wells Branch in Austin, Texas! Choose from our stylish one, two, or three-bedroom apartment floor plans designed to suit your lifestyle. Have questions? Browse our FAQs page to find answers about our community and discover your perfect home today!",
  "property_floorplans_blurb": "Discover your ideal living space at Beck at Wells Branch in Austin, Texas! Our thoughtfully designed one, two, and three-bedroom floor plans cater to every lifestyle. Whether you’re seeking cozy solitude or extra room for loved ones, browse our available apartment homes today and find your perfect floor plan!",
  "property_gallery_blurb": "At Beck at Wells Branch in Austin, Texas, luxurious living comes to life. Our thoughtfully designed one, two, and three-bedroom apartments feature modern amenities like granite countertops and high-speed internet, while the vibrant community offers a refreshing pool, fitness center, and cozy lounge. Picture yourself thriving here in style!",
  "property_interactivemap_blurb": "At Beck at Wells Branch in Austin, Texas, a vibrant lifestyle awaits! Choose from spacious one, two, or three-bedroom apartments adorned with modern features like granite countertops and hardwood floors. Enjoy resort-style amenities, including a refreshing pool, fitness center, and welcoming clubhouse. Find your perfect home with our interactive community map!",
  "property_pets_blurb": null,
  "property_referafriend_blurb": "Discover your ideal home at Beck at Wells Branch, Austin's premier apartment community offering one, two, and three-bedroom floor plans. Enjoy spacious living and vibrant neighborhood amenities. Great friends make great neighbors—refer a friend to our community today and embrace the lifestyle you deserve! View all our floor plans now!",
  "property_residentaccess_blurb": "Welcome to Beck at Wells Branch in Austin, Texas! Explore our spacious one, two, and three-bedroom floor plans designed for modern living. Current residents can easily access the resident portal to pay rent, schedule maintenance, and manage their lifestyle seamlessly. Log in now for convenient community living!",
  "property_reviews_blurb": null,
  "property_created_at": "1752257790569",
  "property_scheduletour_blurb": "Discover your perfect home at Beck at Wells Branch in Austin, Texas. Choose from spacious one, two, or three-bedroom floor plans tailored to your lifestyle. Schedule a tour today and see what our residents have to say about living in our vibrant community! Experience comfort and convenience at Beck at Wells Branch.",
  "property_thankyou_blurb": "Thank you for your interest in Beck at Wells Branch, your ideal Austin, Texas apartment community! Explore our inviting one, two, and three-bedroom floor plans designed for your comfort. A team member will reach out shortly to assist you in finding your perfect home. Stay tuned for more information!",
  "property_virtualtours_blurb": "Discover your perfect home at Beck at Wells Branch in Austin, Texas! Choose from spacious one, two, or three-bedroom floor plans designed for your comfort. Take a virtual tour of our stunning apartments for rent and envision the life you’ll enjoy in our vibrant community. Your new adventure awaits!",
  "property_copyright": "2025 All Rights Reserved. Beck at Wells Branch",
  "property_seo_title_home": "Beck at Wells Branch | Apartments in Austin, Texas",
  "property_seo_description_home": "\"Elevate your lifestyle at Beck at Wells Branch in Austin, Texas! Choose from stylish one, two, or three-bedroom floor plans designed for comfort and convenience. Enjoy resort-style amenities like a sparkling pool, state-of-the-art fitness center, and a dog park, all within a gated community. Experience modern living with high-speed internet, stainless steel appliances, and gorgeous hardwood floors. Embrace a vibrant community with social activities and wellness amenities at your doorstep. Ready to call Beck at Wells Branch home? Your perfect apartment awaits!\"",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Austin, Texas",
  "property_seo_description_floorplans": "Explore the diverse floor plans at Beck at Wells Branch in Austin, Texas! Choose from spacious one, two, and three-bedroom apartments designed for your lifestyle. Browse our available apartment homes to find your perfect floor plan today!",
  "property_seo_title_amenities": "Amenities | Austin, Texas Apartments for Rent",
  "property_seo_description_amenities": "\"Step into luxurious living at Beck at Wells Branch in Austin, Texas. With stunning one, two, and three-bedroom floor plans, our vibrant community offers resort-style amenities including a sparkling pool, fitness center, and pet-friendly spaces. Enjoy the convenience of controlled access, on-site management, and planned social activities while relaxing in beautifully designed apartments featuring granite countertops, high-speed internet, and spacious walk-in closets. Embrace a lifestyle tailored for comfort and connectivity—where home meets the heart of the city.\"",
  "property_seo_title_gallery": "Gallery | Apartments in Austin, Texas",
  "property_seo_description_gallery": "\"Step into elegance and comfort at Beck at Wells Branch in Austin, Texas. Our stunning photo gallery showcases spacious one, two, and three-bedroom floor plans, each featuring modern amenities like granite countertops, hardwood floors, and private balconies. Unwind by the inviting pool, break a sweat in the fitness center, or socialize in the vibrant clubhouse. With pet-friendly options, recycling programs, and convenient online services, your new home awaits. Picture yourself living the good life—explore our captivating community today!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Beck at Wells Branch Apartments",
  "property_seo_description_virtualtours": "Explore Beck at Wells Branch in Austin, Texas! Dive into our diverse floor plans, featuring one, two, and three-bedroom apartments designed for modern living. Ready to find your perfect home? Take a virtual tour of our community and see why Beck at Wells Branch is the ideal choice for your next home!",
  "property_seo_title_interactivemap": "Interactive Map | Beck at Wells Branch Apartments",
  "property_seo_description_interactivemap": "\"Find your perfect retreat at Beck at Wells Branch in vibrant Austin, Texas. Choose from spacious one, two, and three-bedroom apartments loaded with modern amenities, including a sparkling pool, state-of-the-art fitness center, and pet-friendly features. With our interactive community map, effortlessly browse available homes, explore pricing options, and visualize your new lifestyle. Embrace comfort and convenience—your ideal home awaits!\"",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Austin, Texas",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood of Beck at Wells Branch in Austin, Texas! Explore our diverse floor plans including one, two, and three-bedroom apartments. See what's around our community and uncover local favorites, parks, dining spots, and must-visit attractions—all just steps away from your new home. Start your adventure today!",
  "property_seo_title_contact": "Contact Us | Beck at Wells Branch",
  "property_seo_description_contact": "Discover your perfect home at Beck at Wells Branch in Austin, Texas! Explore our spacious floor plans, including one, two, and three-bedroom apartments designed for your comfort. Have questions? Contact our friendly leasing team today and take the first step towards your new lifestyle!",
  "property_seo_title_faqs": "FAQs | Apartments in Austin, Texas",
  "property_seo_description_faqs": "\"At Beck at Wells Branch in Austin, Texas, convenience meets comfort. From spacious one to three-bedroom apartments featuring modern amenities like granite countertops, in-unit laundry, and high-speed internet, to a vibrant community with a pool, fitness center, pet-friendly spaces, and more, we’ve got it all. Have questions? Our Frequently Asked Questions page has you covered—dive in for insights and see what makes us the perfect place to call home!\"",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Austin, Texas",
  "property_seo_description_reviews": "\"At Beck at Wells Branch in Austin, Texas, vibrant living awaits! Experience thoughtfully designed one, two, and three-bedroom apartments, complete with modern amenities like a pool, fitness center, and pet-friendly spaces. Our welcoming community boasts a clubhouse, planned social activities, and convenient features like online services and door-to-door trash pickup. Dive into the authentic resident experience – read reviews and see why our residents love calling Beck home!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Austin, Texas",
  "property_seo_description_applynow": "Nestled in the heart of Austin, the Beck at Wells Branch offers stunning floor plans featuring one, two, and three-bedroom options designed for comfort and style. Enjoy luxury amenities like a refreshing pool, a modern fitness center, and a welcoming clubhouse—all within a gated community. With convenient features such as package service, on-site maintenance, and planned social activities, your ideal living experience awaits. Embrace the perfect blend of relaxation and urban living. Secure your new home today and apply online!",
  "property_seo_title_residentaccess": "Resident Access | Beck at Wells Branch",
  "property_seo_description_residentaccess": "\"Welcome to Beck at Wells Branch in Austin, Texas! Access your resident portal now to easily pay rent, schedule maintenance, and manage your home effortlessly. Your hassle-free living starts here!\"",
  "property_seo_title_referafriend": "Refer A Friend | Beck at Wells Branch",
  "property_seo_description_referafriend": "\"Refer a friend to Beck at Wells Branch in Austin, Texas, and experience the joy of great neighbors! Share your love for our vibrant community and enjoy exclusive rewards. Great friends make great neighbors—start spreading the word today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Beck at Wells Branch",
  "property_seo_description_scheduletour": "\"Discover your ideal home at Beck at Wells Branch in Austin, Texas. Experience our vibrant community and stunning amenities. Schedule a tour today and see why our apartments are the perfect fit for your lifestyle!\"",
  "property_seo_title_privacy": "Privacy Policy | Beck at Wells Branch",
  "property_seo_description_privacy": "Discover the commitment to your privacy at Beck at Wells Branch in Austin, Texas. Our comprehensive privacy policy outlines how we protect your personal information. View our privacy policy to learn more about our practices and how we ensure your data stays secure.",
  "property_seo_title_accessibility": "Website Accessibility | Beck at Wells Branch",
  "property_seo_description_accessibility": "Discover inclusive living at Beck at Wells Branch in Austin, Texas! Our Accessibility Statement reflects our commitment to digital inclusion, ensuring everyone can enjoy a seamless experience. Explore our community’s features and learn how we prioritize accessibility. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Beck at Wells Branch",
  "property_seo_description_sitemap": "\"Explore Beck at Wells Branch in Austin, Texas! Discover our comprehensive sitemap to easily navigate our vibrant apartment community's amenities, floor plans, and services. View our website sitemap today for a seamless living experience!\"",
  "property_seo_title_thankyou": "Thank You | Beck at Wells Branch",
  "property_seo_description_thankyou": "\"Thank you for reaching out to Beck at Wells Branch! We're excited to help you find your perfect home in Austin, Texas. A dedicated team member will contact you shortly to assist with your apartment search. Stay tuned for more information about our vibrant community and exceptional living experience!\"",
  "property_seo_title_pets": null,
  "property_seo_description_pets": null,
  "property_updated_at": "1784584424943",
  "amenities": [
    {
      "id": "ec_cae60c882dbe21e68a5c960e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Controlled Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1dd0d2f66000d86c93325275",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_76856195185444391797af2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Property Manager on Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d84efa9fd812211331814012",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Package Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_73382f04a12a2d35acc25bec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Play Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2b45d2e0b8ac5279e3e95b9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Planned Social Activities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5dbce3c0fb43ad730bd30e48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Recycling",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51eaf10155f00bcd42cdadd0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Trash Pickup - Door to Door",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0fc8a5f7b8107ff81b4151d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5fb099048b196eeedf7df9cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Hearing Impaired Accessible",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_14b9889443156934f28c569f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Maintenance on site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3434432286c3cc852f102684",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Online Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9acf88bc58ba53e513abc05a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Washing Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_83101b1338ee43c07f3f565f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Vision Impaired Accessible",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_340e017fdc51329a04240dc3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e12ffae18bccd74d665fd8e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2339e282432a0d925300352f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Breakfast/Coffee Concierge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_81abee1df088b58a9cd74a7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Conference Rooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3440a350c259b6ffe65972ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-Up",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aa965c79aa6d15c3fbd9cc82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_60f4f2a578c1f6b1260af91c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_925e66b2b3758fc3a1e97b90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Cabana",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f7f0781a712893fb527eddde",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Grill",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7abb9d294704dc55c402b6c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_574c04ebcfe9d290d83ba73c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_885d8c5db7992c068c3139dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "*Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4eb7f68bb0ae985799e2eff8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "24-Hour Resident Package System",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_00e4eb4b923b47c4f5fb2265",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "American Landmark 360 Resident Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cada7a65a5e8d9b2db5a4433",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Attached & Detached Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dcabbc23bff11fadbc65d207",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Bark Park for your Furry Friends",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aa831a834e4c4859d4f83833",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Carports Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2e87b7113f387e39e8180b4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Community Fire Side Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_678c23b58b0a812b266f4371",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Community Outdoor Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d3bfb2dd7be1608f3a97a33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Controlled Access Gates",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_722a0db8831311d8f3e33960",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Convenient 24/7 Online Resident Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c9c7d8e9b92850b67e6ad42f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Convenient Location to Apple; Dell; HP and Samsung",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_908a850c73ccb538f36d1102",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Decorative Ceramic Tile Backsplash",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f9a11e5da312361d0bb1f443",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Dog Washing Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f3599113e05ed874007380b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Easy Access to I35; I45 and Mopac Expressway",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2d21d746b012767360030808",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Frisbee Golf",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d6dd84e44ca560c6102f2acb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Garden Tub",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8881ff4ff17a1f23a052efb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "In-Home Washer & Dryer*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0fcadc86859a3253f1239589",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Onsite Storage Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eb1d60d380d11eea57f5357a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Open Floor Plans",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c4164d888bfe15d9197ca8c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Pantry Closets*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ed6b52410e44d5a581484ef7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Private Patios and Balconies*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0893f96c78deb62a1a7533cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Private Yards on 1st Floor Homes*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_359b920679d78b09d8b83e77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Resident Wifi Lounge & Starbucks Café",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0aaccfa01bca22cfbefb5057",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Sleek Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3e6e27e53cb8bc95a808ec2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Spectrum High-Speed Internet Package with over 200",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c8086970821870c494db2cde",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Spin Studio",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eb5ce207c8f72d1266f61840",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Sunrooms*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_650c20e093d6cac0a97d0fc2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Superior Round Rock ISD",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_da9a07397e5d8561d555c8c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Wood Burning Fireplaces*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3745c3eb38128fa62a0556c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Wood Style Flooring*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_50e15a7fa5ad12ed88ee48db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Yoga Studio",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8d6f4a75a1dae74f2d253756",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_452090d7cba4af3f5f45a1d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3a45d203ee7ebbafb35f3688",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8a3ef65a4e296ff02e012e53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Storage Space",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f5739b47363e0d48436faaba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_23b696f1eac08de0e5eb611a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a5761414e8a1fdde95ce86cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Security System",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a2973f2dad6b164e7fbeeb2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_44ddf1c6ecb33c092c3681dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51fea5092ebdb39afd97000d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Tub/Shower",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_73f3e36afe5db453ffb977c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Framed Mirrors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e6baead35a974122b55751cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Wheelchair Accessible (Rooms)",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d43050689b744f144fc2d112",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ed5f8ad62f3cbed84ff4a3e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b13f79edc2d42260bf42ce60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_62fa40a85ea466b243c2c070",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Eat-in Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_66950b67cbd95283e1f9431e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1d5ba7872a7fb1f775780352",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_14b8d9c1012f7af1c5883ff1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Ice Maker",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_008d2b978fd0ba9bc4f120c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6633901014358a931e20810e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Oven",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5dd2a81e079a54460dea704b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_80a4fae4018a0965707a0115",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c897644f4f4379d55f66b8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Freezer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_47dcc2191e9727ac5501bd2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0b047a57e32a29c765a8e16d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Crown Molding",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8624053c488eff3a2ed0a332",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f3520d3be91957cf2af6acc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Vaulted Ceiling",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_604674211c2d21309fa1189a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Sunroom",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_52e23d98dee28470a6d1b9a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a9cadb5ba2c50d767a6d886e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Carpet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_124eb8581cc54c89d4a4b91e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8936f285b04c643b5231b6d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Linen Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_607fc9728ca383c0cf5dbc22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0265ae56eef99083de822304",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Large Bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c8cd888cf745307b52049d01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a9e21802d957fb1a5a10483",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Yard",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_80cb8517bd7253bc9e3e1212",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Lawn",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8c18924d5c02202a3e29fa47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "external_id": "false",
      "title": "Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_86e1db8b4f37e6928f6b6fd1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019d488a-2caf-7195-908b-738323eae0fc.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and surrounding trees.",
        "public_id": "019d488a-2caf-7195-908b-738323eae0fc",
        "storage_key": "property/6767906449162864/019d488a-2caf-7195-908b-738323eae0fc.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush greenery and comfortable lounge chairs. Perfect for relaxing and unwinding.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and surrounding trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/_JOGepdT23rqxoFLSu3pLUkbXIOh7cqWRVd-9-sUXy0/102/image.jpg"
    },
    {
      "id": "ec_d7fe83052c90520edecc2160",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-4d42-70d8-9435-575f6dadaf44.webp",
      "image_media": {
        "alt_text": "Community coffee bar with a Starbucks logo, modern stools, and decorative items.",
        "public_id": "019cfdda-4d42-70d8-9435-575f6dadaf44",
        "storage_key": "property/6767906449162864/019cfdda-4d42-70d8-9435-575f6dadaf44.webp",
        "width": 1280,
        "height": 720
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and refreshments at our stylish community coffee bar, featuring a Starbucks station and comfortable seating.",
      "link": "false",
      "alt_text": "Community coffee bar with a Starbucks logo, modern stools, and decorative items.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/AxM0R3OCaN7tzcMHvaO1-ViAEDGf-M8JJ4QsQj8dZ6c/102/image.jpg"
    },
    {
      "id": "ec_d7755d7c4f00d960645e7c16",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019d488a-2caf-7195-908b-738323eae0fc.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and surrounding trees.",
        "public_id": "019d488a-2caf-7195-908b-738323eae0fc",
        "storage_key": "property/6767906449162864/019d488a-2caf-7195-908b-738323eae0fc.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush greenery and comfortable lounge chairs. Perfect for relaxing and unwinding.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and surrounding trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/_JOGepdT23rqxoFLSu3pLUkbXIOh7cqWRVd-9-sUXy0/102/image.jpg"
    },
    {
      "id": "ec_90e77673d52646b66a82d9a1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019d488a-2caf-7195-908b-738323eae0fc.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and surrounding trees.",
        "public_id": "019d488a-2caf-7195-908b-738323eae0fc",
        "storage_key": "property/6767906449162864/019d488a-2caf-7195-908b-738323eae0fc.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush greenery and comfortable lounge chairs. Perfect for relaxing and unwinding.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and surrounding trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/_JOGepdT23rqxoFLSu3pLUkbXIOh7cqWRVd-9-sUXy0/102/image.jpg"
    },
    {
      "id": "ec_465ec22415b0979c02083438",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-4c8f-73ba-b526-f42d758fa82a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island, dining area, and living room in an apartment.",
        "public_id": "019cfdda-4c8f-73ba-b526-f42d758fa82a",
        "storage_key": "property/6767906449162864/019cfdda-4c8f-73ba-b526-f42d758fa82a.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "View of a stylish apartment kitchen with an island, leading into the dining and living room areas. Perfect for entertaining or relaxing.",
      "link": "false",
      "alt_text": "Modern kitchen with island, dining area, and living room in an apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/1yr4TAvVF-DdkwXkdRmrvc4nEj7yETyP8fMTuc3UdQA/111/image.jpg"
    },
    {
      "id": "ec_e8861145c0e0a10f9ca0ddbd",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-5019-7410-92d1-1493505070a4.webp",
      "image_media": {
        "alt_text": "View of a modern apartment kitchen and living area with granite countertops and stainless steel appliances.",
        "public_id": "019cfdda-5019-7410-92d1-1493505070a4",
        "storage_key": "property/6767906449162864/019cfdda-5019-7410-92d1-1493505070a4.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Step into this spacious apartment featuring a modern kitchen with granite countertops and stainless steel appliances, flowing into a comfortable living area perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "View of a modern apartment kitchen and living area with granite countertops and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/E2nM19DId6Z0ktX2YL3FKLPDx3JgTiXfsZJP6U4mlME/102/image.jpg"
    },
    {
      "id": "ec_43b664b6f3b34fb138e70f32",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-5956-72c0-a50a-9b57ad4a02e0.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a pantry.",
        "public_id": "019cfdda-5956-72c0-a50a-9b57ad4a02e0",
        "storage_key": "property/6767906449162864/019cfdda-5956-72c0-a50a-9b57ad4a02e0.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "This beautifully appointed kitchen features granite countertops, stainless steel appliances, ample cabinet space, and a convenient pantry for all your storage needs.",
      "link": "false",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a pantry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/z6pjH3p7PXknhGxIe70JspADIRenU-aVZB-qtHdya90/111/image.jpg"
    },
    {
      "id": "ec_2f2d905a244f154ed354b1c9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019d488a-2990-72c3-9f83-04323437981f.webp",
      "image_media": {
        "alt_text": "Stainless steel refrigerator and microwave above a black stove with granite countertops.",
        "public_id": "019d488a-2990-72c3-9f83-04323437981f",
        "storage_key": "property/6767906449162864/019d488a-2990-72c3-9f83-04323437981f.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring dark wood cabinetry, stainless steel appliances, and a granite countertop with a deep sink and gooseneck faucet.",
      "link": "false",
      "alt_text": "Stainless steel refrigerator and microwave above a black stove with granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Admc2QE_mXYpudVbdlRQZs8dO5DNJ-UIyIcx3KrCgA4/102/image.jpg"
    },
    {
      "id": "ec_b3baedaf5fc43f2cbd9b0ef5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-5c4b-73a9-a4d3-a53a5f9203f0.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines and weight equipment",
        "public_id": "019cfdda-5c4b-73a9-a4d3-a53a5f9203f0",
        "storage_key": "property/6767906449162864/019cfdda-5c4b-73a9-a4d3-a53a5f9203f0.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines, weight machines, and free weights for a complete workout experience.",
      "link": "false",
      "alt_text": "Fitness center with cardio machines and weight equipment",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/RohiULDxiCl52JisiOctPuJnO2x2ERPg9xZuUjtDcCQ/119/image.jpg"
    },
    {
      "id": "ec_6ca3cd42737b51a96876e8e7",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-5aef-77fd-8b1f-5620891951da.webp",
      "image_media": {
        "alt_text": "Modern living and dining area with dark gray sofa and table.",
        "public_id": "019cfdda-5aef-77fd-8b1f-5620891951da",
        "storage_key": "property/6767906449162864/019cfdda-5aef-77fd-8b1f-5620891951da.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Stylish living and dining area featuring a tufted sofa, a modern coffee table, and a dining set with chairs. Perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Modern living and dining area with dark gray sofa and table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/xb6_mDQyf93QrQvNn2wjs9gQ8NqkL8kOvrtXPtWRlno/102/image.jpg"
    },
    {
      "id": "ec_5fb5cf8afaa2f5305d456d0e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-6b5b-770e-8544-0728fb946f37.webp",
      "image_media": {
        "alt_text": "Bar area with stools and coffee maker in community lounge.",
        "public_id": "019cfdda-6b5b-770e-8544-0728fb946f37",
        "storage_key": "property/6767906449162864/019cfdda-6b5b-770e-8544-0728fb946f37.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy a morning coffee or evening drink at the stylish community lounge bar, perfect for socializing and relaxing.",
      "link": "false",
      "alt_text": "Bar area with stools and coffee maker in community lounge.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ShMzEBMpHqRfGwmNEmffAMeIdwvN6cAD2Y07DuRUsGE/118/image.jpg"
    },
    {
      "id": "ec_8a3f3f191573c41e591cb0d6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-675f-739b-ba7c-52725f7de38b.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, dresser, and walk-in closet.",
        "public_id": "019cfdda-675f-739b-ba7c-52725f7de38b",
        "storage_key": "property/6767906449162864/019cfdda-675f-739b-ba7c-52725f7de38b.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-sized bed with plush bedding, a rustic dresser, and a convenient walk-in closet, perfect for comfortable living.",
      "link": "false",
      "alt_text": "Bedroom with a king-sized bed, dresser, and walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/JmUKl5BcD6xkdb_jQwor2ZZEYf1pJ_f5XB7qpK2aQLI/102/image.jpg"
    },
    {
      "id": "ec_56a2b68ebe6d562c94ccebce",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-6576-72dc-a645-65ace9b5f53e.webp",
      "image_media": {
        "alt_text": "Lobby area with leather chairs, coffee table, and bar.",
        "public_id": "019cfdda-6576-72dc-a645-65ace9b5f53e",
        "storage_key": "property/6767906449162864/019cfdda-6576-72dc-a645-65ace9b5f53e.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lobby, featuring comfortable seating, a modern bar area, and elegant decor. Perfect for socializing or enjoying a quiet moment.",
      "link": "false",
      "alt_text": "Lobby area with leather chairs, coffee table, and bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/PSo9P0Tl392G4GYZCmKXo168-7K2rN7F6fgFOvJZ5XU/118/image.jpg"
    },
    {
      "id": "ec_c71cc6df72962154fe4da245",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019d5742-fe84-74bd-9019-95d5da937987.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and a subway tile backsplash.",
        "public_id": "019d5742-fe84-74bd-9019-95d5da937987",
        "storage_key": "property/6767906449162864/019d5742-fe84-74bd-9019-95d5da937987.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, elegant granite countertops, ample cabinet space, and a sleek subway tile backsplash.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and a subway tile backsplash.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Ab-t29dPY3_i-gSH3wFoYWaevQ3oSvZWMLBNOaCraHI/104/image.jpg"
    },
    {
      "id": "ec_7e0ed3f46234f81962ddb480",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-741f-728e-825b-113ef274cf42.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and lush landscaping.",
        "public_id": "019cfdda-741f-728e-825b-113ef274cf42",
        "storage_key": "property/6767906449162864/019cfdda-741f-728e-825b-113ef274cf42.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning resort-style pool, surrounded by beautiful greenery and comfortable seating. Perfect for relaxing and soaking up the sun.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and lush landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/vlmYawtX0f1vboreb8zQCqsU0qZj9sNfjHBvg8JdYX4/117/image.jpg"
    },
    {
      "id": "ec_4210563126d2d80983cbe8fa",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019d5743-03ba-7079-8b9d-a87e64e9b304.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, lamp, and ceiling fan.",
        "public_id": "019d5743-03ba-7079-8b9d-a87e64e9b304",
        "storage_key": "property/6767906449162864/019d5743-03ba-7079-8b9d-a87e64e9b304.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "A cozy bedroom featuring a queen-size bed with decorative pillows, a tufted headboard, a nightstand with a lamp, and a modern ceiling fan.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, nightstand, lamp, and ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/R_DDCE7SALj5JRW7B-yzZsqMKstUNVYMXj-ZOV28jzc/104/image.jpg"
    },
    {
      "id": "ec_dc3d4d08611e4857adbd97e2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-76bf-75ee-9f72-c752f412d4c3.webp",
      "image_media": {
        "alt_text": "Dining area with a glass-top table and four upholstered chairs.",
        "public_id": "019cfdda-76bf-75ee-9f72-c752f412d4c3",
        "storage_key": "property/6767906449162864/019cfdda-76bf-75ee-9f72-c752f412d4c3.webp",
        "width": 2000,
        "height": 1387
      },
      "title": "Apartment",
      "description": "Enjoy meals in this elegant dining area, perfect for intimate gatherings or daily dining. Features a stylish glass-top table with comfortable seating.",
      "link": "false",
      "alt_text": "Dining area with a glass-top table and four upholstered chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/daWpNXUVnOXuRsy7oAnEzXL3BozHMFInlX5fV-5M0jI/117/image.jpg"
    },
    {
      "id": "ec_054ff7f092e6e44c3b23accc",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019d5743-06dc-74dc-b22e-d2afdddf7652.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with pergolas, sofas, and coffee tables.",
        "public_id": "019d5743-06dc-74dc-b22e-d2afdddf7652",
        "storage_key": "property/6767906449162864/019d5743-06dc-74dc-b22e-d2afdddf7652.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed outdoor seating area, complete with comfortable sofas and shaded pergolas. Perfect for enjoying the fresh air.",
      "link": "false",
      "alt_text": "Outdoor seating area with pergolas, sofas, and coffee tables.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/mVyuWVSoVBVmU48oHtTFZQBA9OPeV9PeUPHoqLE32Vk/102/image.jpg"
    },
    {
      "id": "ec_913381acb61d88ad37785b7c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-7f56-733e-b413-64017546af90.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and dark wood cabinets.",
        "public_id": "019cfdda-7f56-733e-b413-64017546af90",
        "storage_key": "property/6767906449162864/019cfdda-7f56-733e-b413-64017546af90.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Explore the sleek design of our modern kitchens, featuring stainless steel appliances, granite countertops, and ample storage space.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and dark wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/aAI6c9hgzUFEqhSdWqeiIcI6-K7ipukaMwTwtUEDgY8/117/image.jpg"
    },
    {
      "id": "ec_90343739fe8df396afcdf9f0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-822b-77d2-b751-c69e7323ab5e.webp",
      "image_media": {
        "alt_text": "Spacious seating area with leather sofas and armchairs, a patterned rug, and Union Jack ottomans.",
        "public_id": "019cfdda-822b-77d2-b751-c69e7323ab5e",
        "storage_key": "property/6767906449162864/019cfdda-822b-77d2-b751-c69e7323ab5e.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge area, featuring comfortable seating and a welcoming ambiance. Perfect for socializing or quiet reflection.",
      "link": "false",
      "alt_text": "Spacious seating area with leather sofas and armchairs, a patterned rug, and Union Jack ottomans.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/oiMqN3uuiFtX5YjtLA5SPXmz7q1G2hyvva65iJbagrg/102/image.jpg"
    },
    {
      "id": "ec_72ea45926db5e1a3f0c3002c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-82f1-7408-a284-e772c5885468.webp",
      "image_media": {
        "alt_text": "A bathroom vanity with a sink, granite countertop, and dark cabinets, next to a toilet.",
        "public_id": "019cfdda-82f1-7408-a284-e772c5885468",
        "storage_key": "property/6767906449162864/019cfdda-82f1-7408-a284-e772c5885468.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Experience elegant living in our thoughtfully designed bathrooms, featuring granite countertops and modern cabinetry.",
      "link": "false",
      "alt_text": "A bathroom vanity with a sink, granite countertop, and dark cabinets, next to a toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/pvkHg_Jh2idlcyDAMk8GoWFuhUJ3Mkmdb_KM900pyfM/117/image.jpg"
    },
    {
      "id": "ec_441ea628c0d34bbd52676a2f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-8961-718f-be8d-ed8d10ac362d.webp",
      "image_media": {
        "alt_text": "Modern communal kitchen area with marble island and coffee station.",
        "public_id": "019cfdda-8961-718f-be8d-ed8d10ac362d",
        "storage_key": "property/6767906449162864/019cfdda-8961-718f-be8d-ed8d10ac362d.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and a stylish communal kitchen, perfect for socializing or getting work done.",
      "link": "false",
      "alt_text": "Modern communal kitchen area with marble island and coffee station.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Plh8pQph5g6pnuqtKftLNaBhCKOak4krT13oGvK2m1c/102/image.jpg"
    },
    {
      "id": "ec_7fd4aad85100bd2f7189458c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-8bf1-70fe-aedf-d0f059ad89a9.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops and stainless steel appliances, opening to a living room with a plush sofa and artwork.",
        "public_id": "019cfdda-8bf1-70fe-aedf-d0f059ad89a9",
        "storage_key": "property/6767906449162864/019cfdda-8bf1-70fe-aedf-d0f059ad89a9.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring granite countertops and stainless steel appliances, seamlessly flowing into a stylish living area perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with granite countertops and stainless steel appliances, opening to a living room with a plush sofa and artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/SGTVahqN5paczTfULBhkp6SYvNtf6SVTA5Le6F-5oGE/117/image.jpg"
    },
    {
      "id": "ec_d25cc71c7d14546a38bb86af",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019d5743-2c5f-717f-b646-6c3f46a40d6b.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with built-in grills, dining table, and seating.",
        "public_id": "019d5743-2c5f-717f-b646-6c3f46a40d6b",
        "storage_key": "property/6767906449162864/019d5743-2c5f-717f-b646-6c3f46a40d6b.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings with our community grilling stations and comfortable seating area, perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Outdoor grilling area with built-in grills, dining table, and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ZyYukB4ITLPljYe-Kl7bsEbDggNOBOi8s1vSy91JXT0/104/image.jpg"
    },
    {
      "id": "ec_ed630e0c6d1b74f1b0998755",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-9105-7706-9e5a-2ac1580d4596.webp",
      "image_media": {
        "alt_text": "Beck at Wells Branch Premier Apartments monument sign with address 2801",
        "public_id": "019cfdda-9105-7706-9e5a-2ac1580d4596",
        "storage_key": "property/6767906449162864/019cfdda-9105-7706-9e5a-2ac1580d4596.webp",
        "width": 2000,
        "height": 1126
      },
      "title": "Community",
      "description": "Welcome to Beck at Wells Branch, a premier apartment community. This monument sign, located at 2801, clearly marks the entrance.",
      "link": "false",
      "alt_text": "Beck at Wells Branch Premier Apartments monument sign with address 2801",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/GTXpKTMtDPmt1kdhlhEII51qkjPzUrfk1OvDRVKR1V8/117/image.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_f705ffbf4c97907308f99039",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "poi_name": "Wells Branch Elementary School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_abfe6c5f31550198100a0c16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "poi_name": "Chaparral Star Academy",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_7b8851130ff03fb10388582a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "poi_name": "Renaissance Academy",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [],
  "reviews": [
    {
      "id": "ec_0bb128b3b65ba77ab3c503fb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "4",
      "name": "false",
      "text": "I really liked this place when we moved into here. The longer we're here though we aren't too sure. They take of the property and it's always clean but they find any and every reason to fine you, claim that you haven't paid rent, put notes on your door for not doing so, etc. We have paid rent on time every month since being here and they still claim we are late and owe them a ton of money. We would love to move to a new place but we can't afford it. Winning free rent for life would help us out so much! With a baby on the way we need a bigger apartment!",
      "date": "false",
      "title": "Nice Place"
    },
    {
      "id": "ec_be4281c23f8903c867c8ce2e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "These apartments are nice and in a great area and school district but it's a lot of small issues that start adding up. The paint inside is slapped all over the walls and floor. I constantly have to call maintenance to fix the closet doors. The inside of the tubes are peeling paint. The AC vents are connected to the neighbors so you can smell cigarette smoke or food they're cooking. There is no pantry and very little cabinet space. Available parking spaces is also an issue. They were reasonably priced but are going up on the rent.",
      "date": "false",
      "title": "Nice But Could Be Better"
    },
    {
      "id": "ec_cdc8624c24eb6486d50733d3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "I love the location and the convenient  location, close to a lot. the office staff is very helpful and friendly.",
      "date": "false",
      "title": "Nice Place to live"
    },
    {
      "id": "ec_f598354e8463eb9dc1874097",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "4",
      "name": "false",
      "text": "I have been living at hydes park imt for 2 years and it has been a great experience. The Maintenice arrives on time. The staff is friendly and efficient. Appliances can use an upgrade but other than that it's been a pleasure too live at this location.",
      "date": "false",
      "title": "Great apts"
    },
    {
      "id": "ec_0016dfd7e6d8abad80a06527",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "4",
      "name": "false",
      "text": "I have been living at hydes park imt for 2 years and it has been a great experience. The Maintenice arrives on time. The staff is friendly and efficient. Appliances can use an upgrade but other than that it's been a pleasure too live at this location.",
      "date": "false",
      "title": "Great apts"
    },
    {
      "id": "ec_309578047b948064b7876627",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "4",
      "name": "false",
      "text": "Great location in north Austin. The new management just power washed the entire complex and fixed all of the pot holes and cracks in the parking lot, which made me so happy as a resident!",
      "date": "false",
      "title": "Hyde Park at Wells Branch"
    },
    {
      "id": "ec_726270f30900c2e82de710b2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "4",
      "name": "false",
      "text": "I've been here for 5 months and it has been fantastic. I'm young, and the majority of this complex is families and older people, but I have never found that to be a negative. They are doing a lot of work updating the older apartments and have redone the pools and leasing office to be very nice. The people in the  front office are very friendly and very helpful, in my experience. This complex is two stop lights East of the the Capital Metro rail which is a great (but very overcrowded) option for getting downtown and not worrying about the Austin traffic. Takes 25 minutes with stops to get from the station to downtown and the station has free parking.\n\nNot five stars in my book because of no washer/dryer in the unit (though there are hookups, and renting is pretty cheap) and while the laundry facility gets the job done, it could definitely use an upgrade! That being said, I really like it here and would absolutely renew my lease.",
      "date": "false",
      "title": "Great option for those working downtown"
    },
    {
      "id": "ec_0373d4447e0a6a1bc5da4e77",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "Great community, family oriented & great staff",
      "date": "false",
      "title": "Great community, family... (Verified Renter)"
    },
    {
      "id": "ec_4297c8ecd489272affadf3a8",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "I have so far enjoyed my experience here in this complex. We took a chance in renting inspite of some bad reviews online. But our first impressions based on the office staff, and the service offered made us want to live here.",
      "date": "false",
      "title": "I have so... (Verified Renter)"
    },
    {
      "id": "ec_67be3fdfc014bc5f46419bd0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "I feel very comfortable living here it's safe and quiet. Very clean and well maintained apartments. ",
      "date": "false",
      "title": "I feel very... (Verified Renter)"
    },
    {
      "id": "ec_433f90956dd20c971f534095",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "4",
      "name": "false",
      "text": "Office people were great, the new apartments look very well done.",
      "date": "false",
      "title": "Office people were... (Verified Renter)"
    },
    {
      "id": "ec_6a39b20e596a78c29b4d5b0e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "It's not likely I'd have the opportunity to recommend this apartment community, but given the opportunity, I'd recommend it.",
      "date": "false",
      "title": "It's not likely... (Verified Renter)"
    },
    {
      "id": "ec_8e07bff2d76c87880c699035",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "4",
      "name": "false",
      "text": "The staff makes calling this place home. Hopefully the same staff stays intact. ",
      "date": "false",
      "title": "The staff makes... (Verified Renter)"
    },
    {
      "id": "ec_7031c55213cd6466bf60e167",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "We feel like this is a very nice property and at a fair market price. ",
      "date": "false",
      "title": "We feel like... (Verified Renter)"
    },
    {
      "id": "ec_c7c928f245edc5b0f315b16c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "Nice apartment. Great area. Spacious roomns",
      "date": "false",
      "title": "Nice apartment. Great... (Verified Renter)"
    },
    {
      "id": "ec_bf1a02d31477f441445eceba",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "Your staff is wonderful and always very personable, which I appreciate!",
      "date": "false",
      "title": "Your staff is... (Verified Renter)"
    },
    {
      "id": "ec_d0325a8a54a8bb431701e7e3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "I was apprehensive about moving from a house to apartments. I haven't regretted moving to Hyde Park. The staff from day one have helped me with the transition and I have been  very happy",
      "date": "false",
      "title": "I was apprehensive... (Verified Renter)"
    },
    {
      "id": "ec_1b5955db8177cc4e00f9037b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "4",
      "name": "false",
      "text": "I would because it is a really nice and calm neighborhood. Have good gates and we're close In. Would not because when I moved in this apartment smelled like piss carpet was really nasty stains. Windows are on edge are still broken. But you guys did good replacing my carpet. ",
      "date": "false",
      "title": "I would because... (Verified Renter)"
    },
    {
      "id": "ec_52ec082e84dd579a36d9c08d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "4",
      "name": "false",
      "text": "It's a nice place to live, quiet in my building, and it's close to everything. ",
      "date": "false",
      "title": "It's a nice... (Verified Renter)"
    },
    {
      "id": "ec_1ee51febe71f0f53f9d56272",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "The amenities are very nice, the upgrades in the apartments are well done and the staff is super friendly. ",
      "date": "false",
      "title": "The amenities are... (Verified Renter)"
    },
    {
      "id": "ec_47cc9ad375ab7971aebdb0de",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "I am in the Property Management industry as an Asst Mgr. If I can't help our prospects I always refer them to Hyde Park! ",
      "date": "false",
      "title": "I am in... (Verified Renter)"
    },
    {
      "id": "ec_8a9b775b2fc484134c434e65",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "4",
      "name": "false",
      "text": "I think the location away from downtown would be a tough sell for most of my friends, but it is a gem and is a fantastic value. Best of both worlds being 20 minutes from downtown and 20 minutes from Round Rock.",
      "date": "false",
      "title": "I think the... (Verified Renter)"
    },
    {
      "id": "ec_22077ddae743fa0dd1533057",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "This is a Great Apartment experience. Everyone especially Nicole was very helpful, and made sure I understood everything. The location is beautiful, clean, nice apartment complex. Maintenance looks like they keep up with property well. Staff is Great. Coming into a Renovated, new place is so refreshing. I can tell this team takes care of their Occupants, the Property, which makes a HAPPY HOME!!! I'm so excited for my new home! Thank you!",
      "date": "false",
      "title": "This is a... (Verified Renter)"
    },
    {
      "id": "ec_98ed3f76f23bacbc8c09e5c5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "4",
      "name": "false",
      "text": "When I asked to speak to manager I felt that the person did not want to put me thru to a mgr. all i wanted to ask was if I could please get out of my lease 30 days early since my daughter was in the Houston hospital and she needed me to move with her, where I am now, I had to wait ten days, I was told we will get back to you by Nicole yet she never contacted me, I had to call her and all she said was oh I thought someone else let you know.",
      "date": "false",
      "title": "When I asked... (Verified Renter)"
    },
    {
      "id": "ec_9a8f9f1718e0d4d476b212bc",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "I really like the community. The complex is gorgeous and staff is polite. My only concerns are with maintenance. So far, my experience with them hasn't been the greatest. To start with, we had VERY low water pressure (to the point where we couldn't take a shower). This issue kept being delayed on being fixed. It wasn't actually resolved until 3 visits later (2 weeks after move in). The next issue was with our mailbox. Our mailbox was unable to be locked and left open. This meant that we were unable to receive any mail. This took 2 emails, 2 phone calls, and 5 office visits to get taken care of (ridiculous!). This wasn't resolved until almost a month after move in.",
      "date": "false",
      "title": "I really like... (Verified Renter)"
    },
    {
      "id": "ec_eefb32bbe65082fd1a89eebc",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "The staff are super friendly and nice while maintaining their professionalism. They were able to answer all question and offer advice as well.",
      "date": "false",
      "title": "The staff are... (Verified Renter)"
    },
    {
      "id": "ec_7dc806779be4e2772b3664de",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "The renovation of the apartment looks amazing. For a 1 person, 1 bedroom apartment, there is just enough room for a little social with friends and still have elbow room to walk around :)",
      "date": "false",
      "title": "The renovation of... (Verified Renter)"
    },
    {
      "id": "ec_65ab95bfb82c331bd0d6dc80",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "Maintenance is fantastic in terms of my own experience. The only factors I'd consider in terms of a recommendation have more to do with overall cleanliness. Trash in breezeways, the conditions around the compactor, etc.. It's disgusting.",
      "date": "false",
      "title": "Maintenance is fantastic... (Verified Renter)"
    },
    {
      "id": "ec_6962ee69b45a5b29f925d343",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "The staff were absolutely great. I love the location, and the apartment management was very honest in billing practices. They are also very caring towards residents. This is the best complex I have stayed in, and I totally enjoyed living here.",
      "date": "false",
      "title": "The staff were... (Verified Renter)"
    },
    {
      "id": "ec_3514a92457d37c6eab0570bf",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "4",
      "name": "false",
      "text": "While this is a great apartment with great value, a few things are lacking quality wise. All in  all I would recommend this apartment to others.",
      "date": "false",
      "title": "While this is... (Verified Renter)"
    },
    {
      "id": "ec_4ddaadcb6f09466245907349",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "It's a nice place to call home. What i appreciate most is having the choice to select carpet and having  all the storage space so important too me.",
      "date": "false",
      "title": "It's a nice... (Verified Renter)"
    },
    {
      "id": "ec_d4a857152184d9de1c871267",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "4",
      "name": "false",
      "text": "I personally think it's expensive for this area, especially since this area is known to be a little unsafe. We've had mail stolen, and my boyfriend has had his car hit twice (once it was totaled) by reckless drivers (who were at fault). However, I still enjoy the community because the staff is nice and I love my remodeled unit.",
      "date": "false",
      "title": "I personally think... (Verified Renter)"
    },
    {
      "id": "ec_f54c10cd8e0afdfd23296724",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "4",
      "name": "false",
      "text": "The service was not completely to solve the problem .. the problem is still the same",
      "date": "false",
      "title": "The service was... (Verified Renter)"
    },
    {
      "id": "ec_8c9a05c87ee373f4a7707161",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "Megan was great. She clued us into options we had to get out of our current lease early so we could move into these apartments ASAP.",
      "date": "false",
      "title": "Megan was great.... (Verified Renter)"
    },
    {
      "id": "ec_8a02b270a6455ab19c421478",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "I would recommend this apartment due to the friendly staff and excess amount of parking there is. Also, I work nights and have no issues getting rest during the day.",
      "date": "false",
      "title": "I would recommend... (Verified Renter)"
    },
    {
      "id": "ec_deb37d8893945367984b22b2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "I would recommend these apartments to anyone that can afford.. They have 2 different floor plans I've seen and they are both beautiful. Defiantly would like to live here any day.",
      "date": "false",
      "title": "I would recommend... (Verified Renter)"
    },
    {
      "id": "ec_64df0a5e4d1ba21316a57d89",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "I would definitely recommend this complex to my friends or anyone who would ask.  It has the feel of home, the amenities are fabulous and the staff, friendly, helpful, knowledgeable and professional.",
      "date": "false",
      "title": "I would definitely... (Verified Renter)"
    },
    {
      "id": "ec_2dda72fa6004b7957f0f393c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "YES",
      "date": "false",
      "title": "YES"
    },
    {
      "id": "ec_362025a48ed4f299ee657bc6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "The only issue I have is there is not enough parking and permits / towing is not enforced",
      "date": "false",
      "title": "The only issue... (Verified Renter)"
    },
    {
      "id": "ec_43f9ef33856d64789e36d449",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "The staff they are good and the environment is good  for any responsible person to live it is at home beautiful place to be.",
      "date": "false",
      "title": "The staff they... (Verified Renter)"
    },
    {
      "id": "ec_12def59cf851e98d4e1f3484",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "The Managers were amazing. Shelly was fantastic. She was very attentive to what I wanted, was very kind, and made me feel right at home. I can?t wait to move in!",
      "date": "false",
      "title": "The Managers were... (Verified Renter)"
    },
    {
      "id": "ec_d8f5307bc2df0692c60c9351",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "Starting with the leasing Agent Belinda, our experience from the start has been nothing but positive and pleasant. With maintenance issues, we have only dealt with Louis and he has been nothing but timely, consistent in his delivery of service. In fact  when ever we have questions the entire leasing staff has been very professinal and helpful. Thank you.",
      "date": "false",
      "title": "Starting with the... (Verified Renter)"
    },
    {
      "id": "ec_14f660eaf5318e3466acae68",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "4",
      "name": "false",
      "text": "My personal experiences overall at this complex have been good. If I didn't like the complex, I would have definitely figured out other solutions that would have let me leave the property instead of transferring to a one bedroom when my roommate flaked. I would recommend to someone else.",
      "date": "false",
      "title": "My personal experiences... (Verified Renter)"
    },
    {
      "id": "ec_ee0b82073f549ea730a9a1e9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "4",
      "name": "false",
      "text": "The units are amazing. Its just stepping outside with the dog poop everywhere is the worst!",
      "date": "false",
      "title": "The units are... (Verified Renter)"
    },
    {
      "id": "ec_ed272180eaf6c1860046fb41",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "4",
      "name": "false",
      "text": "If they are looking for a truly secure community, I would not recommend the Hyde Park at Wells Branch, because most of the time one or all of the gates are broken in the open position.",
      "date": "false",
      "title": "If they are... (Verified Renter)"
    },
    {
      "id": "ec_bb5a407fbfcf8e75fd4bd8d5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "4",
      "name": "false",
      "text": "I would recommend Hyde Park at Wells Branch because the transition into the apartment has been great. The maintenance team has been very prompt at helping fix issues from previous tenants and has gotten everything in working order. The office staff is efficient and kind and the complex is generally clean.",
      "date": "false",
      "title": "I would recommend... (Verified Renter)"
    },
    {
      "id": "ec_09f78a906a3e908f008d033a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "I would recommend this apartment community because its safe the the management are the best in handling customers",
      "date": "false",
      "title": "I would recommend... (Verified Renter)"
    },
    {
      "id": "ec_3d6ba5121b583e4a84f9ded9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "This is my second time living here and every experience has been great. The apartments a gorgeous and spacious!",
      "date": "false",
      "title": "This is my... (Verified Renter)"
    },
    {
      "id": "ec_359cdea65f1d4d921710f0c1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "I will tell anyone about these apartments.these apartments are awesome ??",
      "date": "false",
      "title": "I will tell... (Verified Renter)"
    },
    {
      "id": "ec_edf61a64ee17aecb5bc46e65",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "i love this comunity..nice people ..peaceful..amazing service ..has been my home for 10 now",
      "date": "false",
      "title": "i love this... (Verified Renter)"
    },
    {
      "id": "ec_24b7fc6a009bc6ad3f65b821",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "I've already recommended several of my friends to move here because of cost and environment!",
      "date": "false",
      "title": "I've already recommended... (Verified Renter)"
    },
    {
      "id": "ec_c206ee8b269a8b428bacd737",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "Nice community, friendly personnel at the apartment complex, convenient location without being in the crowded downtown area, close to major highways, nice apartment buildings, and great amenities.",
      "date": "false",
      "title": "Nice community, friendly... (Verified Renter)"
    },
    {
      "id": "ec_3746049d643ecc8ea11362a7",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "Loved everything about the apartment. My leasing agent Victoria was great too!",
      "date": "false",
      "title": "Loved everything about... (Verified Renter)"
    },
    {
      "id": "ec_c63d02eeac132971635b3ea9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "I would recommend this to friends and family I love the community",
      "date": "false",
      "title": "I would recommend... (Verified Renter)"
    },
    {
      "id": "ec_f54210b692ee07089926bcd2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "4",
      "name": "false",
      "text": "Parking is always an issue and at the end of the day who wants to have to fight for a parking spot . Only other option is pay extra for covered parking",
      "date": "false",
      "title": "Parking is always... (Verified Renter)"
    },
    {
      "id": "ec_659b046b2d7fb50f831138bf",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "I have leased sight unseen. Belinda has been responsive and when she has been off Jason has been a great help. Very professional. I haven't seen the apartment yet but we are relocating from another city so based off what they have described it will be a good place for home for the next 2 years while we build a home.",
      "date": "false",
      "title": "I have leased... (Verified Renter)"
    },
    {
      "id": "ec_2a317a17587552a82c79deae",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "4",
      "name": "false",
      "text": "Hyde Park @ Wells Branch has improved but can improve a bit more. Safety features can be added (security patrol onsite); benches along the gate (especially for the kids to sit for the bus); additional weight room (by the other pool) *not being utilized...  I would recommend it, though. :0)",
      "date": "false",
      "title": "Hyde Park @... (Verified Renter)"
    },
    {
      "id": "ec_656417ba82ff6346f0187406",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "They're super nice apartments and in a very good area",
      "date": "false",
      "title": "They're super nice... (Verified Renter)"
    },
    {
      "id": "ec_35a29a975989aff941d156be",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "4",
      "name": "false",
      "text": "It is a good value for the location and the apartment sizes are nice.",
      "date": "false",
      "title": "It is a... (Verified Renter)"
    },
    {
      "id": "ec_dac3c794aaba3d8ec149bed6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "4",
      "name": "false",
      "text": "The delay from the initial report of a problem is concerning as it was off season for an AC repair.",
      "date": "false",
      "title": "The delay from... (Verified Renter)"
    },
    {
      "id": "ec_5ed21c091ee9ad6f9342c0ba",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "I would definitely recommend this complex to my friends or anyone who would ask. It has the feel of home, the amenities are fabulous and the staff, friendly, helpful, knowledgeable and professional.",
      "date": "false",
      "title": "I would definitely... (Verified Renter)"
    },
    {
      "id": "ec_fac2b76ff91edaff439dbef8",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "rating": "5",
      "name": "false",
      "text": "My visit was great. Everyone was extremely nice and informative. The property is nice. Also, I spoke with Sophia, who made me feel very welcomed. ",
      "date": "false",
      "title": "Wonderful"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_906b5480d7fcf724a69c6ef8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Caption",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/8l1n4y?source=180"
    },
    {
      "id": "ec_612fd8ca5331c4b711fec42b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Virtual Tour 2",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/7n1g2l?source=180"
    },
    {
      "id": "ec_261db9a0dcc7c2f1d921a543",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Virtual Tour 3",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/CJbxYTzPgvc?source=180"
    },
    {
      "id": "ec_0b00ce8502272cb3429a9d96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-4c8f-73ba-b526-f42d758fa82a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen and living room with island and blue accent wall.",
        "public_id": "019cfdda-4c8f-73ba-b526-f42d758fa82a",
        "storage_key": "property/6767906449162864/019cfdda-4c8f-73ba-b526-f42d758fa82a.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "1BR1BA- 698SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=rvfBFDEBMDf"
    },
    {
      "id": "ec_1655de1629fa7181b3250d6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-5019-7410-92d1-1493505070a4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "View of a modern apartment kitchen and living area with granite countertops and stainless steel appliances.",
        "public_id": "019cfdda-5019-7410-92d1-1493505070a4",
        "storage_key": "property/6767906449162864/019cfdda-5019-7410-92d1-1493505070a4.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "2BR, 2BA - 1,150SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=C3EixHtfHYS"
    },
    {
      "id": "ec_c4f5ab212e2c33f864928abc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162864",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Compact 698 sq. ft. apartment with 1 bedrooms and 1 bathroom. Features modern kitchen, spacious living area, and ample natural light. Located in Austin, TX, this single-story unit offers contemporary design and efficient use of space.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162864/019cfdda-5956-72c0-a50a-9b57ad4a02e0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and ample cabinet space.",
        "public_id": "019cfdda-5956-72c0-a50a-9b57ad4a02e0",
        "storage_key": "property/6767906449162864/019cfdda-5956-72c0-a50a-9b57ad4a02e0.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "A1 | 1 Bedroom & 1 Bathroom - 698 Sq.Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7FVbQCAZdjW"
    }
  ],
  "faqs": [],
  "lead_collectors": [],
  "hyperlocal_queries": [],
  "custom_fields": [
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Rise"
    }
  ],
  "custom_rollout_phase": "Phase 1",
  "custom_vibesites_theme": "Rise"
};

export const generatedAt = '2026-10-05T18:31:58.455Z';
